export default __webpack_public_path__ + "components/weather-icon/static/nightclear@2-b58597a158f8338e3049f7e495527205.png";